var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"menuMsg",staticStyle:{"width":"100%","height":"32%"}},[_vm._v(_vm._s(_vm.menuItem.menuMsg))])
}
var staticRenderFns = []

export { render, staticRenderFns }